import dynamic from 'next/dynamic';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
const SitemapContent = dynamic(() => import('../components/static/sitemap'), { loading: () => <></>, ssr: true });
import { withRouter } from 'next/router';
// import { fetchFaculties, fetchStaff } from '../api/faculty';

function Sitemap(props) {
	
	const meta = {
		title: "Bayan Sitemap",
		description: "BAYAN SITEMAP",
		route: "sitemap",
	}
	return (
		<>
			<Layout theme={props.theme} meta={meta}>
				<SitemapContent />
			</Layout>
		</>
	);
}

export default withRouter(Sitemap);
